import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { UsertokenService } from '@shared-angular/services/usertoken.service';


const endInvalidRoute = async (router: Router) => {
  await router.navigate(["/", "403"]);
};

export const externalaccessGuard: CanActivateFn = async (route, _state) => {
  const router = inject(Router);
  const http = inject(HttpClient);
  const usertokenService = inject(UsertokenService);
  const accesstoken = route.queryParamMap.get("authtoken");

  if (accesstoken == "" || accesstoken == null) {
    await endInvalidRoute(router);
  }

  try {
    const result = await firstValueFrom(http.post<{ redirect: string, token: string }>("/api/auth/externaluser", { token: accesstoken }));
    usertokenService.setUserTokenAfterAuth(result.token);
    window.location.href = result.redirect;
    return false;
  } catch (_e) {
    console.error("Error during external access authentication");
  }
  await endInvalidRoute(router);
  return false;
};
